/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProjectSettingFeaturesAppEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const projectSettingFeaturesAppEntryPoint: EntryPoint<
	ProjectSettingFeaturesAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ProjectSettingFeaturesAppEntryPointComponent>(
		/* webpackChunkName: "async-project-settings-features-app" */ './ProjectSettingsFeaturesApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
